import { isIdentityVerificationEnabled } from "../../utils/identityVerification";

export const getAdvancedConditions = (showPmsOptions, settings) => [
  ...(showPmsOptions ? [
    {
      type: "balance",
      label: "Pending Balance*",
      options: [
        { label: "Ignore", value: "" },
        { label: "Pending", value: "balance_pending" },
        { label: "Paid In Full", value: "paid_in_full" },
      ],
    },
    {
      type: "contract",
      label: "Contract Signed*",
      options: [
        { label: "Ignore", value: "" },
        { label: "Not Signed", value: "contract_pending" },
        { label: "Signed", value: "contract_signed" },
      ],
    },
  ] : []),
  ...(isIdentityVerificationEnabled(settings) ? [{
    type: "guest_id_verification",
    label: "Guest ID Verification",
    options: [
      { label: "Ignore", value: "" },
      { label: "Pending", value: "guest_id_verification_pending" },
      { label: "Success", value: "guest_id_verification_completed" },
    ],
  }] : []),
];
